module.exports = __webpack_public_path__ + "img/img48.befbae11.png";